import React from "react";

export default function FormBoxIndex({children}){

    return(
        <div className="form-container">
          <div className="desc-card mt-4">
            <div className="card-body col-sm-12 text-label-left">
              {children}
            </div>
          </div>        
        </div>
    )

}